import React, { useState } from 'react';
import {
  RiAddFill,
  RiDeleteBinLine,
  RiEdit2Line,
  RiEditLine,
  RiMapPinLine,
} from 'react-icons/ri';
import {
  Button,
  Chip,
  Divider,
  IconButton,
  Modal,
} from '../../../../../components/UiComponents/Ui';

import { editSupplierLocationInfoSchema } from './setupValidators';
import { submitEditSupplierLocations } from './setupActions';
import { useGlobalContext } from '../../../../../Contexts/GlobalContext';
import AddLocationModal from '../../../../../components/UiComponents/AddLocationModal';
import SubmitButton from '../../../../../components/UiComponents/SubmitButton';
import { formateZodError } from '../../../../../Utlils';
import { LocationCard } from '../../../../../components/UiComponents/InfoCards';

const EditLocationInfo = ({
  supplierID,
  locationDetails,
  supplierDetailsMutate,
}) => {
  const [editLocationInfo, setEditLocationInfo] = useState(false);
  const [locationData, setLocationData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [singleLocationDetails, setSingleLocationDetails] = useState({});
  const [singleLocationModal, setSingleLocationModal] = useState(false);
  const { setSnackbar } = useGlobalContext();

  const handleClose = () => {
    setLocationData({});
    setEditLocationInfo(false);
    setFormErrors({});
  };

  const handleDelete = (index) => {
    setLocationData((prev) => ({
      locations: prev?.locations?.filter((_, i) => i !== index),
    }));
  };

  const handleOpenEdit = (index, loc) => {
    setSingleLocationDetails({ index, location: loc, mode: 'edit' });
    setFormErrors({});
    setSingleLocationModal(true);
  };

  const handleOpenAdd = () => {
    setSingleLocationDetails({ mode: 'add', index: undefined, location: {} });
    setFormErrors({});
    setSingleLocationModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const validationResult = editSupplierLocationInfoSchema.safeParse({
        ...locationData,
        _id: supplierID,
      });

      if (validationResult.success) {
        const response = await submitEditSupplierLocations({
          ...validationResult.data,
          _id: supplierID,
        });
        if (!response?.error) {
          setSnackbar({
            open: true,
            msg: 'Supplier Details updated successfully!',
            severity: 'success',
          });
          supplierDetailsMutate();
          handleClose();
        } else {
          setSnackbar({
            open: true,
            msg: 'Internal Server Error! Please try again!',
            severity: 'error',
          });
        }
      } else {
        setFormErrors(formateZodError(validationResult.error.errors));
      }
    } catch (error) {
      console.log('error in handleSubmit from edit Supplier info', error);
      setSnackbar({
        open: true,
        msg: 'Internal Server Error! Please try again!',
        severity: 'error',
      });
    }
  };
  const handleCloseSingleLocationModal = () => {
    setSingleLocationModal(false);
    setSingleLocationDetails({});
    setFormErrors({});
  };

  // Update the location currently being edited in the child modal
  const handleSingleLocationDataChange = (updater) => {
    setSingleLocationDetails((prev) => {
      const currentLocation = prev?.location || {};

      return {
        ...prev,
        location:
          typeof updater === 'function' ? updater(currentLocation) : updater,
      };
    });
  };

  const locations = locationData?.locations || [];

  return (
    <div>
      <IconButton
        aria-label="Edit locations"
        variant="ghost"
        onClick={() => {
          setEditLocationInfo(true);
          setLocationData({ locations: locationDetails });
        }}
      >
        <RiEditLine size={20} />
      </IconButton>

      <Modal
        showModal={editLocationInfo}
        setShowModal={handleClose}
        closeOnOutsideClick={false}
        width={600}
      >
        <form className="space-y-[18px]" onSubmit={handleSubmit}>
          <h2 className="text-lg font-semibold text-gray-800">
            View Locations
          </h2>
          <Divider />

          <div className="mainContainerScroll max-h-[400px] space-y-2 overflow-y-auto pr-2">
            {locationData?.locations?.length === 0 && (
              <div className="flex flex-col items-center justify-center gap-2 py-10 text-gray-400">
                <RiMapPinLine size={36} />
                <p className="text-sm">No locations added yet</p>
              </div>
            )}

            {locations.map((loc, i) => (
              <LocationCard
                key={i}
                item={loc}
                alwaysShowActions
                onEdit={() => handleOpenEdit(i, loc)}
                onRemove={
                  locations.length > 1 ? () => handleDelete(i) : undefined
                }
              />
            ))}
          </div>

          <Button
            fullWidth
            variant="outlined"
            startIcon={<RiAddFill size={18} />}
            onClick={handleOpenAdd}
          >
            Add New Location
          </Button>
          <Divider />
          <div className="flex items-center justify-end gap-2">
            <Button variant="outlined" intent="default" onClick={handleClose}>
              Cancel
            </Button>
            <SubmitButton name="Save Changes" />
          </div>
        </form>
      </Modal>

      {/* <AddLocationModal
        showModal={singleLocationModal}
        setShowModal={setSingleLocationModal}
        singleLocationDetails={singleLocationDetails}
        setSingleLocationDetails={setSingleLocationDetails}
        formErrors={formErrors}
        setFormErrors={setFormErrors}
        setLocationData={setLocationData}
        edit={singleLocationDetails?.mode === 'edit'}
      /> */}

      <AddLocationModal
        showModal={singleLocationModal}
        setShowModal={setSingleLocationModal}
        handleCloseModal={handleCloseSingleLocationModal}
        modalData={singleLocationDetails?.location || {}}
        setModalData={handleSingleLocationDataChange}
        setCustomerData={setLocationData}
        ediIndex={singleLocationDetails?.index}
        edit={singleLocationDetails?.mode === 'edit'}
      />
    </div>
  );
};

export default EditLocationInfo;
